// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"styles_breadCrumb__m3O_I","tagClass":"styles_tagClass__6U2a5","titleClass":"styles_titleClass__8WMDr"};